module.exports = __webpack_public_path__ + "static/fonts/Fact-SemiExpandedBold.e4355cd.eot";